import React from 'react';
import { Check } from 'lucide-react';
import { PricingTier as PricingTierType } from '../../types';
import Button from '../ui/Button';

interface PricingTierProps {
  tier: PricingTierType;
  isRecommended?: boolean;
}

const PricingTier: React.FC<PricingTierProps> = ({ tier, isRecommended }) => {
  return (
    <div className={`card p-8 flex flex-col h-full transition-all duration-300 ${
      isRecommended 
        ? 'border-primary relative bg-primary/5' 
        : 'hover:border-primary/50'
    }`}>
      {isRecommended && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-background px-4 py-1 rounded-full text-sm font-medium">
          Our Recommendation
        </div>
      )}

      <div className="min-h-[160px] flex flex-col">
        <h3 className="text-2xl font-bold mb-4">{tier.name}</h3>
        <p className="text-neutral-300 flex-grow">{tier.description}</p>
      </div>

      <div className="space-y-6 mb-8">
        <div className="min-h-[80px]">
          <p className="text-sm uppercase tracking-wider text-primary mb-2">Best For</p>
          <p className="text-neutral-200">{tier.idealFor}</p>
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm uppercase tracking-wider text-primary mb-2">Timeline</p>
            <p className="text-neutral-200">{tier.timeline}</p>
          </div>
          <div>
            <p className="text-sm uppercase tracking-wider text-primary mb-2">Hours</p>
            <p className="text-neutral-200">{tier.hours}</p>
          </div>
        </div>
      </div>

      <div className="flex-grow">
        <p className="text-sm uppercase tracking-wider text-primary mb-4">What's included</p>
        <ul className="space-y-4">
          {tier.features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check size={20} className="text-primary mr-3 flex-shrink-0 mt-1" />
              <span className="text-neutral-200">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-8 pt-8 border-t border-neutral-700">
        <a 
          href="https://calendly.com/productleapai/30min"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full"
        >
          <Button className="w-full">Book a Call</Button>
        </a>
      </div>
    </div>
  );
};

export default PricingTier;